import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { specialDealDto, SpecialDealResponseDTO } from "./models";

export class SpecialDealApi {
  static getSpecialDeal = async () => {
    const response = GbApiRequestService.post(
      "userRpc",
      new URLSearchParams({
        type: JSON.stringify({
          dataMap: {
            mode: "getAllBannersInfo",
          },
          processorClass: "SpecialDealAndBanners",
        }),
      }),
    );

    const validatedData = await withSchemaValidation(
      response,
      SpecialDealResponseDTO,
    );

    let result = specialDealDto(validatedData);
    if (result.success) {
      return result.data.requestDTO.dataMap;
    } else {
      return undefined;
    }
  };
}
